import { getAllUpcomingEvents } from "../../lib/events";
import { EventListClientComponent } from "./event-list-client";

export async function EventListComponent({
  pageData,
}: {
  pageData: { locale: string };
}) {
  const { locale } = pageData;
  const events = await getAllUpcomingEvents(locale);

  return <EventListClientComponent events={events} />;
}
